module.exports = __webpack_public_path__ + "static/pregnancy960_2270-73d25e2cec24b9566a97bb829bb5965c.png";